export function getPowerlearningRoutes() {
  return [
    {
      path: "/powerlearning/analytics",
      name: "powerlearning-analytics",
      component: () => import("./views/PowerlearningAnalytics.vue"),
    },
  ]
}
